import { render, staticRenderFns } from "./ColourSwatch.vue?vue&type=template&id=f7870706"
import script from "./ColourSwatch.vue?vue&type=script&lang=js"
export * from "./ColourSwatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports